import React from "react";

const DataTable = ({
  title,
  columns,
  data,
  actions = null,
  emptyMessage = "No records found.",
}) => {
  return (
    <div className="bg-white rounded-3xl shadow-lg overflow-hidden">

      {/* Header */}
      <div className="px-6 py-5 border-b">

        <h2 className="text-2xl font-bold text-gray-800">
          {title}
        </h2>

      </div>

      {/* Table */}

      <div className="overflow-x-auto">

        <table className="w-full">

          <thead className="bg-gray-100">

            <tr>

              {columns.map((column) => (

                <th
                  key={column.key}
                  className="px-6 py-4 text-left text-sm font-semibold text-gray-700"
                >
                  {column.label}
                </th>

              ))}

              {actions && (

                <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700">

                  Actions

                </th>

              )}

            </tr>

          </thead>

          <tbody>

            {data.length > 0 ? (

              data.map((row, index) => (

                <tr
                  key={row.id || index}
                  className="border-b hover:bg-gray-50 transition"
                >

                  {columns.map((column) => (

                    <td
                      key={column.key}
                      className="px-6 py-4 text-gray-700"
                    >
                      {row[column.key] ?? "-"}
                    </td>

                  ))}

                  {actions && (

                    <td className="px-6 py-4">

                      <div className="flex justify-center gap-2">

                        {actions(row)}

                      </div>

                    </td>

                  )}

                </tr>

              ))

            ) : (

              <tr>

                <td
                  colSpan={actions ? columns.length + 1 : columns.length}
                  className="py-10 text-center text-gray-500"
                >
                  {emptyMessage}
                </td>

              </tr>

            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default DataTable;